/* ============================================================
   NeoSpherium · device-saved wishlist (localStorage).
   Heart toggles on product cards + PDP; nav heart count; a /pages/wishlist
   page renders the saved items from window.NSWishlist.read(). No account
   needed (per-device); upgrades to account-sync when Customer Accounts ship.
   Stores a small snapshot per item so the wishlist page renders without fetches.
   ============================================================ */
(function () {
  var KEY = 'ns-wishlist';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ns-wishlist:change', { detail: { count: list.length } }));
  }
  function has(id) { return read().some(function (x) { return String(x.id) === String(id); }); }
  function remove(id) { write(read().filter(function (x) { return String(x.id) !== String(id); })); }
  function toggle(item) {
    var list = read();
    var i = -1, k;
    for (k = 0; k < list.length; k++) { if (String(list[k].id) === String(item.id)) { i = k; break; } }
    if (i >= 0) { list.splice(i, 1); } else { list.unshift(item); }
    write(list);
    return i < 0; // true => now saved
  }

  function itemFromHeart(h) {
    return {
      id: h.getAttribute('data-wish-id'),
      title: h.getAttribute('data-wish-title') || '',
      url: h.getAttribute('data-wish-url') || '',
      image: h.getAttribute('data-wish-image') || '',
      price: h.getAttribute('data-wish-price') || '',
      vendor: h.getAttribute('data-wish-vendor') || '',
      variant: h.getAttribute('data-wish-variant') || '',
      handle: h.getAttribute('data-wish-handle') || ''
    };
  }

  function paintHeart(h) {
    var on = has(h.getAttribute('data-wish-id'));
    h.classList.toggle('is-saved', on);
    h.setAttribute('aria-pressed', on ? 'true' : 'false');
    h.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
  }
  function syncHearts(scope) { (scope || document).querySelectorAll('.wish-heart').forEach(paintHeart); }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function onHeart(h) {
    var nowSaved = toggle(itemFromHeart(h));
    h.classList.toggle('is-saved', nowSaved);
    h.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
    h.setAttribute('aria-label', nowSaved ? 'Remove from wishlist' : 'Save to wishlist');
    // gentle pop
    h.classList.remove('wish-pop'); void h.offsetWidth; h.classList.add('wish-pop');
  }

  function bind(scope) {
    (scope || document).querySelectorAll('.wish-heart').forEach(function (h) {
      if (h.dataset.wishBound) return; h.dataset.wishBound = '1';
      h.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onHeart(h); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onHeart(h); }
      });
    });
  }

  function init() { bind(); syncHearts(); updateCount(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); syncHearts(e.target); });
  document.addEventListener('ns-wishlist:change', function () { updateCount(); syncHearts(); });

  window.NSWishlist = { read: read, has: has, toggle: toggle, remove: remove, bind: bind, syncHearts: syncHearts };
})();
